import * as React from 'react'
import { SVGProps } from 'react'

const ADAUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='15.994' cy='15.9941' r='15.994' fill='white' />
    <path
      d='M11.1782 15.9127C11.1327 16.7031 11.7411 17.3798 12.5316 17.4253C12.56 17.4253 12.5884 17.4253 12.6169 17.4253C13.413 17.4253 14.0556 16.7827 14.0499 15.9866C14.0499 15.1905 13.4073 14.5479 12.6112 14.5536C11.8492 14.5536 11.218 15.1507 11.1782 15.9127Z'
      fill='#0033AD'
    />
    <path
      d='M5.821 15.5431C5.56488 15.5261 5.34291 15.7253 5.33153 15.9814C5.32015 16.2375 5.51366 16.4595 5.76977 16.4708C6.02589 16.4879 6.24216 16.2887 6.25924 16.0326C6.27631 15.7765 6.07711 15.5602 5.821 15.5431Z'
      fill='#0033AD'
    />
    <path
      d='M11.0872 7.57704C11.3148 7.46321 11.4059 7.17864 11.2921 6.95098C11.1782 6.72332 10.8937 6.63226 10.666 6.74609C10.4383 6.85992 10.3473 7.1388 10.4611 7.36646C10.5749 7.59981 10.8538 7.69656 11.0872 7.57704C11.0872 7.57704 11.0815 7.57704 11.0872 7.57704Z'
      fill='#0033AD'
    />
    <path
      d='M12.5416 10.1181C12.8941 9.94184 13.0363 9.50967 12.86 9.1571C12.6837 8.80454 12.2515 8.66238 11.899 8.83866C11.5464 9.01494 11.4043 9.44712 11.5805 9.79968C11.7568 10.1522 12.189 10.2944 12.5416 10.1181Z'
      fill='#0033AD'
    />
    <path
      d='M7.63972 11.8639C7.91267 12.0402 8.27661 11.9663 8.45857 11.6933C8.63486 11.4204 8.56093 11.0564 8.28798 10.8744C8.01503 10.6982 7.65109 10.7721 7.46912 11.045C7.28715 11.318 7.36676 11.6876 7.63972 11.8639Z'
      fill='#0033AD'
    />
    <path
      d='M8.50947 15.2872C8.11141 15.2645 7.77591 15.5659 7.75316 15.9639C7.73041 16.362 8.0318 16.6975 8.42986 16.7202C8.82791 16.743 9.16342 16.4416 9.18616 16.0435C9.20891 15.6512 8.90752 15.31 8.50947 15.2872Z'
      fill='#0033AD'
    />
    <path
      d='M7.72065 20.1037C7.43063 20.2516 7.31122 20.6041 7.45907 20.8998C7.60692 21.1898 7.95948 21.3093 8.25518 21.1614C8.54519 21.0136 8.66461 20.661 8.51676 20.3653C8.36891 20.0753 8.01066 19.9559 7.72065 20.1037Z'
      fill='#0033AD'
    />
    <path
      d='M10.5072 13.803C10.8995 14.0589 11.4227 13.9508 11.6729 13.5584C11.9288 13.1661 11.8207 12.6429 11.4284 12.3927C11.036 12.1368 10.5128 12.2449 10.2626 12.6372C10.0067 13.0239 10.1148 13.5471 10.5072 13.803Z'
      fill='#0033AD'
    />
    <path
      d='M19.3493 10.0613C19.6791 10.2774 20.1284 10.1864 20.3445 9.85661C20.5606 9.52679 20.4696 9.07756 20.1398 8.86147C19.8099 8.64538 19.3607 8.73637 19.1446 9.06619C18.9228 9.40169 19.0138 9.84524 19.3493 10.0613Z'
      fill='#0033AD'
    />
    <path
      d='M20.8165 7.53146C21.0328 7.67375 21.3173 7.61114 21.4596 7.39486C21.6019 7.17859 21.5393 6.89402 21.323 6.75173C21.1067 6.60944 20.8222 6.67205 20.6799 6.88263C20.5433 7.09891 20.6059 7.38917 20.8165 7.53146Z'
      fill='#0033AD'
    />
    <path
      d='M19.4564 14.5423C18.666 14.4968 17.9836 15.1053 17.9438 15.8957C17.8983 16.6861 18.5068 17.3685 19.2972 17.4083C19.3256 17.4083 19.3541 17.4083 19.3768 17.4083C20.1672 17.4083 20.8098 16.7657 20.8098 15.9696C20.8155 15.2133 20.2184 14.5821 19.4564 14.5423Z'
      fill='#0033AD'
    />
    <path
      d='M13.0142 13.7007C13.2587 14.184 13.7535 14.4911 14.2994 14.4911C15.0898 14.4911 15.7324 13.8485 15.7324 13.0524C15.7324 12.8306 15.6812 12.6089 15.5788 12.4042C15.2206 11.6933 14.3562 11.409 13.6511 11.7673C12.9403 12.1312 12.656 12.9956 13.0142 13.7007Z'
      fill='#0033AD'
    />
    <path
      d='M24.2681 11.8639C24.5581 11.716 24.6719 11.3578 24.524 11.0678C24.3762 10.7778 24.0179 10.664 23.7279 10.8119C23.4379 10.9597 23.3242 11.3123 23.4663 11.6023C23.6199 11.8923 23.9724 12.0117 24.2681 11.8639Z'
      fill='#0033AD'
    />
    <path
      d='M20.6286 12.3188C20.2135 12.5292 20.0429 13.0353 20.2533 13.4504C20.4637 13.8655 20.9698 14.0361 21.385 13.8257C21.8001 13.6153 21.9707 13.1092 21.7603 12.6941C21.5499 12.279 21.0438 12.1141 20.6286 12.3188Z'
      fill='#0033AD'
    />
    <path
      d='M15.937 7.31468C16.2611 7.33174 16.5398 7.08153 16.5625 6.7574C16.5853 6.43327 16.3294 6.15463 16.0052 6.13188C15.6811 6.11482 15.4025 6.35934 15.3797 6.68348C15.3627 7.01329 15.6129 7.29193 15.937 7.31468Z'
      fill='#0033AD'
    />
    <path
      d='M15.9309 11.028C16.3972 11.0564 16.7953 10.6982 16.818 10.2319C16.8465 9.76559 16.4882 9.36753 16.0219 9.34478C15.5556 9.31635 15.1576 9.6746 15.1348 10.1409C15.1121 10.6072 15.4646 11.0052 15.9309 11.028Z'
      fill='#0033AD'
    />
    <path
      d='M11.3596 19.6488C11.7747 19.4384 11.9453 18.9323 11.7349 18.5171C11.5245 18.102 11.0184 17.9314 10.6033 18.1418C10.1881 18.3522 10.0175 18.8583 10.2279 19.2734C10.4384 19.6886 10.9445 19.8592 11.3596 19.6488Z'
      fill='#0033AD'
    />
    <path
      d='M16.4773 12.262C16.0451 12.9273 16.2271 13.8144 16.8924 14.2466C17.5577 14.6787 18.4448 14.4968 18.877 13.8315C19.3092 13.1661 19.1272 12.279 18.4619 11.8469C18.2287 11.6933 17.9558 11.6137 17.6772 11.6137C17.1938 11.6137 16.7446 11.8582 16.4773 12.262Z'
      fill='#0033AD'
    />
    <path
      d='M18.9734 18.2669C18.6151 17.5561 17.7508 17.2718 17.0456 17.63C16.3348 17.9883 16.0505 18.8526 16.4088 19.5577C16.767 20.2685 17.6314 20.5529 18.3365 20.1946C19.0416 19.8421 19.3316 18.9891 18.9791 18.2783C18.9791 18.2726 18.9791 18.2726 18.9734 18.2669Z'
      fill='#0033AD'
    />
    <path
      d='M21.4811 18.1646C21.0887 17.9087 20.5656 18.0168 20.3154 18.4091C20.0595 18.8015 20.1675 19.3247 20.5599 19.5749C20.9523 19.8308 21.4754 19.7227 21.7256 19.3304C21.9815 18.9437 21.8735 18.4205 21.4811 18.1646Z'
      fill='#0033AD'
    />
    <path
      d='M24.234 16.0094C24.2568 15.6113 23.9554 15.2758 23.5573 15.2531C23.1593 15.2304 22.8238 15.5317 22.801 15.9298C22.7783 16.3279 23.0797 16.6634 23.4777 16.6861C23.8701 16.7088 24.2113 16.4018 24.234 16.0094Z'
      fill='#0033AD'
    />
    <path
      d='M26.2185 15.4977C25.9623 15.4806 25.7404 15.6798 25.729 15.9359C25.7176 16.192 25.9111 16.414 26.1672 16.4254C26.4234 16.4424 26.6396 16.2432 26.6567 15.9871C26.6681 15.731 26.4746 15.5147 26.2185 15.4977Z'
      fill='#0033AD'
    />
    <path
      d='M24.347 20.1036C24.074 19.9274 23.7101 20.0013 23.5281 20.2742C23.3519 20.5472 23.4258 20.9111 23.6987 21.0931C23.9717 21.2694 24.3356 21.1954 24.5176 20.9225C24.6996 20.6495 24.6199 20.2799 24.347 20.1036Z'
      fill='#0033AD'
    />
    <path
      d='M11.1661 24.4368C10.9498 24.2946 10.6653 24.3572 10.523 24.5678C10.3807 24.784 10.4433 25.0686 10.6539 25.2109C10.8701 25.3532 11.1547 25.2906 11.297 25.08C11.445 24.8694 11.3824 24.5791 11.1661 24.4368Z'
      fill='#0033AD'
    />
    <path
      d='M20.9014 24.3913C20.6737 24.5052 20.5826 24.7897 20.6965 25.0174C20.8103 25.245 21.0949 25.3361 21.3225 25.2223C21.5502 25.1085 21.6412 24.8296 21.5274 24.6019C21.4136 24.3686 21.1347 24.2718 20.9014 24.3913C20.9014 24.3913 20.907 24.3913 20.9014 24.3913Z'
      fill='#0033AD'
    />
    <path
      d='M15.5102 19.7056C15.9424 19.0402 15.7604 18.1531 15.0951 17.7153C14.4298 17.2831 13.5427 17.4651 13.1048 18.1304C12.6669 18.7957 12.8546 19.6828 13.5199 20.1207C13.7531 20.2742 14.026 20.3538 14.3047 20.3538C14.7937 20.3595 15.2429 20.115 15.5102 19.7056Z'
      fill='#0033AD'
    />
    <path
      d='M12.6397 21.9062C12.3099 21.6901 11.8606 21.7811 11.6446 22.1109C11.4285 22.4407 11.5194 22.89 11.8493 23.1061C12.1791 23.3222 12.6283 23.2312 12.8444 22.9014C13.0662 22.5715 12.9752 22.1223 12.6397 21.9062Z'
      fill='#0033AD'
    />
    <path
      d='M15.9883 24.6529C15.6641 24.6359 15.3855 24.8861 15.3627 25.2102C15.34 25.5343 15.5959 25.813 15.92 25.8357C16.2441 25.8528 16.5228 25.6083 16.5455 25.2841C16.5626 24.9543 16.3124 24.6757 15.9883 24.6529Z'
      fill='#0033AD'
    />
    <path
      d='M15.9932 20.9396C15.5269 20.9111 15.1288 21.2694 15.1061 21.7357C15.0776 22.202 15.4359 22.6 15.9022 22.6228C16.3685 22.6455 16.7665 22.293 16.7893 21.8267C16.8177 21.3661 16.4595 20.9623 15.9932 20.9396Z'
      fill='#0033AD'
    />
    <path
      d='M19.4458 21.8495C19.0932 22.0314 18.9511 22.4636 19.1331 22.8162C19.315 23.1687 19.7472 23.3109 20.0998 23.1289C20.4523 22.9526 20.5945 22.5205 20.4182 22.1679C20.2362 21.8153 19.8041 21.6675 19.4458 21.8495Z'
      fill='#0033AD'
    />
  </svg>
)

export default ADAUSD
